import { AppBar, Box, Stack, Typography } from '@mui/material';
import MaintenanceImage from '../../assets/png/maintenanceImage.png';
import ConfideLogoWhite from '../../assets/svg/confideLogoWhite.svg';
import { FormattedMessage } from 'react-intl';

function maintenancePage() {
  return (
    <Box sx={{ background: '#FFFFFF', height: '100vh' }}>
      <AppBar position='sticky'>
        <Stack
          direction='row'
          px={5}
          py={3.125}
          sx={{
            background: (theme) =>
              `linear-gradient(270deg, ${theme.palette.teal.main} 0%, ${theme.palette.blue.main} 100%)`,
          }}
        >
          <img
            src={ConfideLogoWhite}
            alt='Confide Logo'
            style={{ maxWidth: '155px' }}
          />
        </Stack>
      </AppBar>
      <Stack
        width='100%'
        justifyContent='center'
        gap={3}
        p={2}
        sx={{ background: '#FFFFFF' }}
      >
        <Stack direction='row' justifyContent='center'>
          <Box sx={{ maxWidth: '1116px' }} mt={17} mb={13}>
            <img
              src={MaintenanceImage}
              alt='Maintenance'
              style={{ width: '100%', height: 'auto' }}
            />
          </Box>
        </Stack>
        <Stack direction='row' justifyContent='center'>
          <Stack justifyContent='center' gap={3.5} flexGrow={1}>
            <Stack direction='row' justifyContent='center'>
              <Typography
                sx={{
                  textAlign: 'center',
                  fontSize: 'clamp(26px, 5vw, 32px)',
                  fontWeight: '600',
                  lineHeight: '125%',
                  width: 'clamp(300px, 100%, 750px)',
                }}
              >
                <FormattedMessage defaultMessage="We're currently upgrading the Confide Platform to improve your experience." />{' '}
                &#128736;&#65039;
              </Typography>
            </Stack>
            <Stack direction='row' justifyContent='center'>
              <Typography
                sx={{
                  color: (theme) => theme.palette.neutralWhiteBg[500],
                  textAlign: 'center',
                  fontSize: 'clamp(14px, 3vw, 18px);',
                  fontWeight: '400',
                  lineHeight: '150%',
                  width: 'clamp(250px, 100%, 700px)',
                }}
              >
                <FormattedMessage defaultMessage='We expect to be back and better within the next few hours. We appreciate your patience and understanding if we take a bit longer. Quality is our top priority!' />
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}

export default maintenancePage;
